export default "__VITE_ASSET__D7zp8RZZ__"